module.exports = __webpack_public_path__ + "img/256.69fb12f4.webp";